export const NAV_CONFIG = [
  {
    key: "HOME",
    displayName: "Home",
    url: "/",
  },
  {
    key: "BUY",
    displayName: "Buy",
    url: "/buy",
  },
  {
    key: "SELL",
    displayName: "Sell",
    url: "/sell",
  },
  {
    key: "ABOUT_US",
    displayName: "About Us",
    url: "/aboutus",
  },
];
